import { useEffect } from 'react'
import { api } from '../api'
import { useApp } from '../context'
import { useAsync } from '../hooks'
import { PanelShell } from './PanelShell'
import { Badge, Button, Empty, ErrorState, Loading, Section } from './ui'

export function AuditPanel() {
  const { open, setHighlight, nodeName } = useApp()
  const q = useAsync(() => api.audit(), [])
  useEffect(() => setHighlight({}), [setHighlight])
  if (!q.data) return q.error ? <ErrorState error={q.error} onRetry={q.reload} /> : <Loading />
  return (
    <PanelShell
      title="Audit log"
      subtitle="Every change to connectivity records, newest first"
      actions={
        <Button size="sm" onClick={q.reload}>
          Refresh
        </Button>
      }
    >
      <Section title={`${q.data.entries.length} entries`}>
        {!q.data.entries.length && <Empty title="No changes yet">Splices you add or remove appear here with who and when.</Empty>}
        <ol className="space-y-2">
          {q.data.entries.map((e) => (
            <li key={e.id} className="rounded-lg border border-border p-2.5 text-sm">
              <div className="flex flex-wrap items-center gap-2">
                <Badge tone={e.action.endsWith('delete') ? 'warn' : 'accent'} icon={false}>
                  {e.action === 'connection.create' ? 'Splice added' : 'Splice removed'}
                </Badge>
                <button className="font-medium hover:text-accent" onClick={() => open({ kind: 'node', id: e.nodeId })}>
                  {nodeName(e.nodeId)}
                </button>
              </div>
              <div className="mt-1 break-words">{e.summary}</div>
              <div className="mt-1 text-xs text-muted">
                {e.actor} · <time dateTime={e.at}>{new Date(e.at).toLocaleString()}</time>
              </div>
            </li>
          ))}
        </ol>
      </Section>
    </PanelShell>
  )
}
